// extracted by mini-css-extract-plugin
export default {"mCard":"eD-z","image":"fD-z","imageNoBackground":"gD-z","imageHasCategory":"hD-z","fullWidth":"iD-z"};